const ClaimsConfigurations = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">
        Claims Configurations
      </h1>
      <p className="mt-2 text-sm text-gray-500">
        Claims-specific configuration routes will be migrated here.
      </p>
    </div>
  );
};

export default ClaimsConfigurations;
